import React from 'react';
import { IconProps } from './types/Icon.type';

function QuestionIcon(props: IconProps) {
  return (
    <svg
      width={props.boxSize ?? '16'}
      height={props.boxSize ?? '16'}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.45801 9.40039V9.45898H8.4541V9.40039C8.46875 8.60449 8.69824 8.25293 9.28418 7.89648C9.9043 7.51562 10.2803 6.99316 10.2803 6.20703C10.2803 5.09375 9.43066 4.33203 8.16113 4.33203C6.99902 4.33203 6.06152 5.01074 6.02246 6.25586H7.07715C7.12109 5.5332 7.63379 5.21094 8.16113 5.21094C8.74707 5.21094 9.21582 5.59668 9.21582 6.20703C9.21582 6.71973 8.90332 7.08105 8.49316 7.33008C7.84863 7.73047 7.47266 8.12109 7.45801 9.40039ZM7.30176 10.875C7.29688 11.2559 7.61426 11.5635 7.99512 11.5684C8.37109 11.5635 8.68359 11.2559 8.68848 10.875C8.68359 10.4941 8.37109 10.1816 7.99512 10.1816C7.61426 10.1816 7.29688 10.4941 7.30176 10.875Z"
        fill={props.fill ?? '#121212'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
        fill={props.fill ?? '#121212'}
      />
    </svg>
  );
}

export default QuestionIcon;
